// apps/web/src/stores/theme.ts
// Per. Persists 'light' | 'dark' to localStorage['magimp:theme'];
// applies `data-theme` attribute on <html> on every `set`.
import { create } from 'zustand';

export type ThemeMode = 'light' | 'dark';

interface ThemeState {
  theme: ThemeMode;
  set: (theme: ThemeMode) => void;
  toggle: () => void;
}

function readInitial(): ThemeMode {
  try {
    const raw = localStorage.getItem('magimp:theme');
    return raw === 'dark' ? 'dark' : 'light';
  } catch {
    return 'light';
  }
}

export const useThemeStore = create<ThemeState>((set, get) => ({
  theme: readInitial(),
  set: (theme) => {
    try {
      localStorage.setItem('magimp:theme', theme);
    } catch {
      // Non-fatal — storage unavailable (private mode, quota). Still update in-memory state.
    }
    if (typeof document !== 'undefined') {
      document.documentElement.setAttribute('data-theme', theme);
    }
    set({ theme });
  },
  toggle: () => get().set(get().theme === 'light' ? 'dark' : 'light'),
}));
